import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const FolderIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 14 13" },
        React.createElement("path", { d: "M13.5 2.00001H6.02185C5.80774 2.00001 5.61768 1.86305 5.54999 1.65992L5.10999 0.33997C5.0423 0.13697 4.8523 0 4.63831 0H0.5C0.22388 0 0 0.22388 0 0.5V12.5C0 12.7761 0.22388 13 0.5 13H13.5C13.7761 13 14 12.7761 14 12.5V2.50001C14 2.22389 13.7761 2.00001 13.5 2.00001Z" })));
};

export { FolderIcon };
//# sourceMappingURL=FolderIcon.esm.js.map
